module.exports = __webpack_public_path__ + "static/img/rppghealthapp6.bf0d213.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rppghealth/rppghealthapp6.png
// module id = sqUu
// module chunks = 5